import React, {CSSProperties} from "react";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import {palette} from "../palette";
export const KyrLoader = ({style}: {style?: CSSProperties}) => (
  <Box style={{flexGrow: 1, display: "flex", alignItems: 'center', justifyContent: 'center', ...style}}>
    <CircularProgress style={{color: palette.primary}} />
  </Box>
)